import { memo } from "react";
import { cn } from "@/shared/lib/utils";
import { useJobCounter } from "../../hooks/useJobCounter";

type JobFloatingIndicatorProps = { className?: string };

/**
 * Pastille flottante signalant qu'au moins une tâche async est en cours.
 * Utilisée sur l'item parent « Outils » (accordéon replié) et sur l'icône
 * « Tâches » en mode sidebar réduite, où le JobCounter du sous-item n'est
 * pas monté. Réutilise le style de pulse de JobCounter / NotificationBadge
 * pour la cohérence visuelle. Self-gate à `null` quand aucune tâche ne tourne.
 * Le positionnement absolu est fourni par l'appelant via `className`.
 */
const JobFloatingIndicator = memo(({ className }: JobFloatingIndicatorProps) => {
  const count = useJobCounter();

  if (!count) return null;

  return (
    <span
      aria-label="Tâche en cours"
      role="status"
      className={cn("relative flex size-2.5 rounded-full bg-red-600", className)}
    >
      <span className="absolute inset-0 rounded-full bg-red-400 opacity-75 animate-pulse" />
    </span>
  );
});

JobFloatingIndicator.displayName = "JobFloatingIndicator";

export default JobFloatingIndicator;
